import { TokenResource } from './resources/token';
import { UserResource } from './resources/user';

export class AuthResource {
  private readonly tokenResource: TokenResource;
  private readonly userResource: UserResource;

  constructor() {
    this.tokenResource = new TokenResource();
    this.userResource = new UserResource();
  }

  get token() {
    return this.tokenResource;
  }

  get user() {
    return this.userResource;
  }
}

export { TokenResource } from './resources/token';
export { UserResource } from './resources/user';
